import axios from 'axios';
import router from '../router';

const state = {
  menus: [],
  currentMenu: null,
  menuItems: [],
};

const mutations = {
  SET_MENUS(state, menus) {
    state.menus = menus;
  },
  SET_CURRENT_MENU(state, menu) {
    state.currentMenu = menu;
  },
  SET_MENU_ITEMS(state, items) {
    state.menuItems = items;
  },
};

const getters = {
  activeMenu: (state) => {
    const today = new Date().toISOString().split('T')[0];
    return state.menus.find(m => 
      m.is_active === 1 && 
      m.start_date <= today && 
      m.end_date >= today
    );
  },
};

const actions = {
  async fetchMenus({ commit }) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    try {
      const response = await axios.get(`${baseURL}/menus`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      commit('SET_MENUS', response.data);
    } catch (error) {
      console.error('Error fetching menus:', error);
      throw error;
    }
  },

  async fetchMenu({ commit }, menuId) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      const response = await axios.get(`${baseURL}/menus/${menuId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      commit('SET_CURRENT_MENU', response.data);
      commit('SET_MENU_ITEMS', response.data.items || []);
      return response.data;
    } catch (error) {
      console.error('Error fetching menu:', error);
      throw error;
    }
  },

  async createMenu({ dispatch }, menuData) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      await axios.post(`${baseURL}/menus`, menuData, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      await dispatch('fetchMenus');
    } catch (error) {
      console.error('Error creating menu:', error);
      throw error;
    }
  },

  async updateMenu({ dispatch }, { menuId, menuData }) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      await axios.put(`${baseURL}/menus/${menuId}`, menuData, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      await dispatch('fetchMenus');
    } catch (error) {
      console.error('Error updating menu:', error);
      throw error;
    }
  },

  async deleteMenu({ dispatch }, menuId) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      await axios.delete(`${baseURL}/menus/${menuId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      await dispatch('fetchMenus');
    } catch (error) {
      console.error('Error deleting menu:', error);
      throw error;
    }
  },

  async addMenuItems({ dispatch }, { menuId, itemIds }) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      await axios.post(`${baseURL}/menus/${menuId}/items`, { item_ids: itemIds }, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      await dispatch('fetchMenu', menuId);
      await dispatch('fetchMenus');
    } catch (error) {
      console.error('Error adding menu items:', error);
      throw error;
    }
  },

  async removeMenuItem({ dispatch }, { menuId, itemId }) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      await axios.delete(`${baseURL}/menus/${menuId}/items/${itemId}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      await dispatch('fetchMenu', menuId);
      await dispatch('fetchMenus');
    } catch (error) {
      console.error('Error removing menu item:', error);
      throw error;
    }
  },

  async updateMenuItemOrder({ state }, menuId) {
    let baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
    const userToken = localStorage.getItem('userToken');

    try {
      const itemIds = state.menuItems.map(i => i.itemId);
      await axios.put(`${baseURL}/menus/${menuId}/order`, { item_ids: itemIds }, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
    } catch (error) {
      console.error('Error updating order:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};